import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DropzoneComponent from 'react-dropzone-component';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import PhotosList from '../PhotosList';
import showToaster from '../../helpers/toasterMessages/showToaster';
import messages from '../../locale/jsonMessages';
import dropzoneError from '../../helpers/dropzoneError';
import { createListPhotos, removeListPhotos } from '../../actions/manageListPhotos';
import { stopProfilePhotoLoader } from '../../actions/manageUserProfilePicture';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';

import documentIcon from '/public/SiteIcons/photoUpload.svg';
import s from 'react-dropzone-component/styles/filepicker.css';
import t from 'dropzone/dist/min/dropzone.min.css';
import u from '../../styles/documentUploadDropzone.css';

class PhotosUpload extends Component {

  static propTypes = {
    createListPhotos: PropTypes.any.isRequired,
    removeListPhotos: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.dropzone = null;
    this.state = {
      djsConfig: {}
    }
  }

  componentDidMount() {
    const { placeholder, maxUploadSize } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== undefined;
    if (isBrowser && isDocument) {
      document.querySelector(".dz-hidden-input").style.visibility = 'visible';
      document.querySelector(".dz-hidden-input").style.opacity = '0';
      document.querySelector(".dz-hidden-input").style.height = '100%';
      document.querySelector(".dz-hidden-input").style.width = '100%';
      document.querySelector(".dz-hidden-input").style.cursor = 'pointer';
    }

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: "",
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          acceptedFiles: 'image/jpeg, image/png, image/jpg',
          hiddenInputContainer: '.dzInputContainer'
        }
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { placeholder, maxUploadSize } = this.props;

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: "",
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          acceptedFiles: 'image/jpeg, image/png, image/jpg',
          hiddenInputContainer: '.dzInputContainer'
        }
      });
    }
  }

  error = (file) => {
    const { stopProfilePhotoLoader, maxUploadSize } = this.props;

    dropzoneError(file, maxUploadSize);
    this.dropzone.removeFile(file);
    stopProfilePhotoLoader();
  }

  addedfile = async (file) => {
    const { maxUploadSize, stopProfilePhotoLoader, userRestriction, listId } = this.props;
    let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

    const isRestrict = await userRestriction({ restrictType: 'listing', restrictValue: listId });
    if (isRestrict) {
      this.dropzone.removeFile(file);
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      return;
    }

    if (!isOnline) {
      showToaster({ messageId: 'offlineError', toasterType: 'error' })
      this.dropzone.removeFile(file);
      stopProfilePhotoLoader();
      return;
    }
    if (file?.size > (1024 * 1024 * parseInt(maxUploadSize))) {
      showToaster({ messageId: 'maximumUploadSize', toasterType: 'error' })
      this.dropzone.removeFile(file);
    }
  }

  complete = async (file) => {
    const { listId, createListPhotos, userRestriction } = this.props;

    const isRestrict = await userRestriction({ restrictType: 'listing', restrictValue: listId });
    if (isRestrict) {
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      this.dropzone.removeFile(file);
      return;
    }

    if (file && file.xhr) {
      const { files } = JSON.parse(file.xhr.response);
      let fileName = files[0].filename;
      let fileType = files[0].mimetype;
      if (listId != undefined) {
        createListPhotos(listId, fileName, fileType);
      }
      this.dropzone.removeFile(file);
    }
  }

  render() {
    const { placeholder, listId, maxUploadSize } = this.props;
    const { djsConfig } = this.state;
    const componentConfig = {
      iconFiletypes: ['.jpg', '.png', 'jpeg'],
      postUrl: '/photos'
    };
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      success: this.success,
      complete: this.complete,
      addedfile: this.addedfile,
      error: this.error
    };

    return (
      <div className={'documentUploadDropzoneContainer'}>
        <div className={'dzInputContainer'}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            <img src={documentIcon} className={cx('documentUploadDropzoneIcon')} alt='PictureImage' />
            <span className={'documentUploadDropzonePlaceholder'}>{placeholder}</span>
            <div className={'maxUploadSizeText'}>
              <FormattedMessage {...messages.uploadSizedLabel} />{' '}{maxUploadSize}MB
            </div>
          </DropzoneComponent>
        </div>
        <PhotosList listId={listId} />
      </div>
    );
  }
}

const mapState = (state) => ({
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize
});

const mapDispatch = {
  createListPhotos,
  removeListPhotos,
  stopProfilePhotoLoader,
  userRestriction
};

export default injectIntl(withStyles(s, t, u)(connect(mapState, mapDispatch)(PhotosUpload)));
